const siteConfig = {
  brandName: "filverparcel",
  legalName: "KYING TECHNOLOGY LIMITED",
  logo: "/head/filverparcel-wordmark.svg",
  mark: "/head/filverparcel-mark.svg",
  tagline: "thoughtfully in transit",
  description:
    "Everyday clothing presented with clear product details, calm styling and an unhurried point of view.",
  currency: "USD",
  locale: "en-US",
  contact: {
    email: "best@filverparcel.store",
    phone: "+49 (0) 211 000 000",
    address:
      "RM A8, UNIT A, 5/F TAK WING IND BLDG, 3 TSUN WEN RD, TUEN MUN, HONG KONG",
    addressLines: [
      "RM A8, UNIT A, 5/F TAK WING IND BLDG",
      "3 TSUN WEN RD, TUEN MUN",
      "HONG KONG",
    ],
    hours: "Monday–Friday · 09:00–17:00 CET",
  },
  shipping: {
    freeThreshold: 150,
    standardRate: 6.95,
    dispatchWindow: "1–2 working days",
    returnsWindow: 30,
  },
};

export const formatPrice = (value) =>
  new Intl.NumberFormat(siteConfig.locale, {
    style: "currency",
    currency: siteConfig.currency,
  }).format(Number(value));

export default siteConfig;
